import { render, staticRenderFns } from "./RefreshView.vue?vue&type=template&id=4b51ce58&"
import script from "./RefreshView.vue?vue&type=script&lang=js&"
export * from "./RefreshView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports